export default __webpack_public_path__ + "static/media/logo_saymee.56f523c0.svg";